import { FIELDS_OF_LAW_ENDPOINT } from 'common/constants'
import { request } from 'common/utils'
import { FieldOfLawInput } from 'packages-mui/advice/interfaces'

import query from '../graphql/updateFieldOfLaw.graphql'
import { UpdateFieldOfLawMutation } from '../interfaces/schemaDefinition'

export const updateFieldOfLaw = (fieldOfLaw: FieldOfLawInput): Promise<UpdateFieldOfLawMutation> =>
  request<UpdateFieldOfLawMutation>(FIELDS_OF_LAW_ENDPOINT, query, { fieldOfLaw })
